import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import SneakerGuidePage from "../pages/article/sneaker-guide/page";
import EinkaufsguidePage from "../pages/article/einkaufsguide/page";
import SicherheitGuidePage from "../pages/article/sicherheit-guide/page";
import VersandGuidePage from "../pages/article/versand-guide/page";
import AnfaengerGuidePage from "../pages/article/anfaenger-guide/page";
import StreetwearGuidePage from "../pages/article/streetwear-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/oopbuy-spreadsheet-deutsch-erklaert",
    element: <ArticlePage />,
  },
  {
    path: "/oopbuy-sneaker-spreadsheet-guide",
    element: <SneakerGuidePage />,
  },
  {
    path: "/einkaufsguide",
    element: <EinkaufsguidePage />,
  },
  {
    path: "/oopbuy-sicherheit-datenschutz-guide",
    element: <SicherheitGuidePage />,
  },
  {
    path: "/oopbuy-versand-deutschland-guide",
    element: <VersandGuidePage />,
  },
  {
    path: "/oopbuy-spreadsheet-anfaenger-guide",
    element: <AnfaengerGuidePage />,
  },
  {
    path: "/oopbuy-streetwear-hoodie-guide",
    element: <StreetwearGuidePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;